import React, { useEffect, useState, useRef } from 'react';
import logo from '../../images/logo.png';
import './Profile.css';
import { Link as Anchor } from 'react-router-dom';
import baseURL from '../url';
import { InstagramIcon, FacebookIcon, WhatsAppIcon, TikTokIcon } from '../SocialIcons/SocialIcons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

export default function Profile({ onClose }) {
    const [contactos, setContactos] = useState([]);
    const [images, setImages] = useState([]);


    useEffect(() => {
        cargarContacto();
        cargarBanners();
    }, []);

    const cargarBanners = () => {
        fetch(`${baseURL}/bannersGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const bannerImages = data.banner.map(banner => banner.imagen);
                setImages(bannerImages);
            })
            .catch(error => {
                console.error('Error al cargar productos:', error)

            });
    };
    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setContactos(data.contacto.reverse()[0] || []);

            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const handleInstallClick = () => {
        if (typeof onClose === 'function') {
            onClose();
        }
        window.dispatchEvent(new CustomEvent('open-pwa-install'));
    };

    return (
        <div className='profileContain'>
            <div className='fondo'>
                <img src={images[0]} alt={`imagen`} />
            </div>
            <div className='profileText'>
                <img src={logo} alt="" />
                <h2>{contactos.nombre}</h2>
                {contactos.descripcion_tienda && (
                    <p style={{ margin: '0.2rem 0 0.6rem 0', fontSize: '0.9rem', color: '#64748b' }}>
                        {contactos.descripcion_tienda}
                    </p>
                )}
                {contactos.email && (
                    <Anchor to={`mailto:${contactos.email}`} target="_blank">{contactos.email}</Anchor>
                )}
                {contactos.direccion && (
                    <Anchor to={`https://www.google.com/maps?q=${encodeURIComponent(contactos.direccion)}`} target="_blank">{contactos.direccion}</Anchor>
                )}
                <div className='socials'>
                    <Anchor to={contactos.instagram || '#'} target="_blank" className="socialBtn instagram" title="Instagram"><InstagramIcon /></Anchor>
                    <Anchor 
                        to={contactos.tiktok && contactos.tiktok !== '#' 
                            ? (contactos.tiktok.startsWith('http') ? contactos.tiktok : `https://tiktok.com/@${contactos.tiktok.replace(/^@/, '')}`) 
                            : '#'} 
                        target="_blank" 
                        className="socialBtn tiktok"
                        title="TikTok"
                    >
                        <TikTokIcon />
                    </Anchor>
                    <Anchor to={`tel:${contactos.telefono}`} target="_blank" className="socialBtn whatsapp" title="WhatsApp"><WhatsAppIcon /></Anchor>
                    <Anchor to={contactos.facebook || '#'} target="_blank" className="socialBtn facebook" title="Facebook"><FacebookIcon /></Anchor>
                </div>
                <button
                    type="button"
                    className="btnInstallAppProfile"
                    onClick={handleInstallClick}
                    title="Instalar App en tu celular o computadora"
                >
                    <FontAwesomeIcon icon={faDownload} />
                    <span>Instalar App</span>
                </button>
            </div>
        </div>
    )
}
